import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PluginTemplate } from "types/generated";

const PluginTemplatesTableNameCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PluginTemplate>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{template.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default PluginTemplatesTableNameCell;
